export default "__VITE_ASSET__TVJWhuUI__"